import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule, MatDialogRef,} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatTooltipModule} from "@angular/material/tooltip";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {Store} from '@ngrx/store';

import {MatSelectModule} from '@angular/material/select';
import {PaperChatFilterType} from '../../dto/paper-chat';
import {selectFilterType} from '../../service/paper-chat.selector';
import {setChatFilterType} from '../../service/paper-chat.actions';
import {loadProjectHasEmbeddingOverview} from '../../service/embedding.actions';
import {selectProjectEmbeddingsOverview} from '../../service/embedding.selectors';
import {EMPTY, Observable, Subscription} from 'rxjs';
import {ProjectHasEmbeddingOverviewDTO} from '../../dto/embedding';
import {PaperChatFilterComponent} from '../paper-chat-filter/paper-chat-filter.component';


interface Option {
  value: string;
  viewValue: string;
  enabled: boolean;
  count?: number;
}

@Component({
  selector: 'app-paper-chat-setting-dialog',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    PaperChatFilterComponent
],
  templateUrl: './paper-chat-setting-dialog.component.html',
  styleUrl: './paper-chat-setting-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaperChatSettingDialogComponent {
  private readonly dialogRef: MatDialogRef<PaperChatSettingDialogComponent> = inject(MatDialogRef);

  @ViewChild('paperChatFilter') paperChatFilter?: PaperChatFilterComponent;

  projectId = 1;
  invalid = false;


  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if(this.paperChatFilter){
      this.paperChatFilter.save();
    }
    this.dialogRef.close(true);
  }
}
